<div class="page-body-de">
  <div class="contents-container-de">
    <ng-content></ng-content>
  </div>
</div>
